

export const SEAT_BADGE_BASE_URL = 'https://rukmini-ct.flixcart.com/f_auto,q_auto,c_fill,e_sharpen:90/staticresource-prod/images/logos/smb_logos'

export const SEAT_ICON_URL = `${SEAT_BADGE_BASE_URL}/SeatImage-2x.png`
export const STAR_ICON_URL = `${SEAT_BADGE_BASE_URL}/StarIcon-2x.png`
export const PINK_STAR_URL = `${SEAT_BADGE_BASE_URL}/TinyPinkStar-2x.png`
export const YELLOW_STAR_URL = `${SEAT_BADGE_BASE_URL}/recommended_seat_star_icon-2x.png`


// CT Upgrade icons for recommended seats
export const MINI_CT_UPGRADE_ICON_URL = `${SEAT_BADGE_BASE_URL}/Ct-Upgrade-Icon-2x.png`
export const CT_UPGRADE_ARROW_ICON_URL = `${SEAT_BADGE_BASE_URL}/ct-upgrade-arrow-icon-2x.png`

// CT Upgrade selection background color
export const CT_UPGRADE_SELECTION_BG_COLOR = '#F83C00'

// CT Upgrade benefit type constant
export const CT_UPGRADE_BENEFIT_TYPE = 'CT_UPGRADE'

/** API / state keys for aircraft layout decks */
export const DECK_KEYS = {
    LOWER: 'lowerDeck',
    UPPER: 'upperDeck',
} as const

/** Lower / upper deck toggle UI copy */
export const DECK_TOGGLE_COPY = {
    LOWER_LABEL: 'Lower Deck',
    UPPER_LABEL: 'Upper Deck',
    ARIA_LABEL: 'Aircraft deck',
} as const

/** Shown when the selected deck has no seat map compartments */
export const DECK_MAP_UNAVAILABLE_MESSAGE = {
    UPPER: 'Upper deck seat map is not available for this flight.',
    LOWER: 'Lower deck seat map is not available for this flight.',
} as const